import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LinkIcon from "@mui/icons-material/Link";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import { Button, ButtonGroup, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

import { shareLinkForConversation } from "../requests";
import { ShareConversationDialog } from "../ShareConversationDialog";
import { useSnackbarStore } from "common/services/snackbar";
import { useLanguage } from "contexts/LanguageContext";

import * as S from "./style";
import type { ShareConversationButtonProps } from "./types";

export function ShareConversationButton(props: ShareConversationButtonProps) {
  const notify = useSnackbarStore((s) => s.notify);
  const { t } = useLanguage();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);

  const copyLink = async () => {
    setMenuAnchor(null);
    try {
      // No token to mint — the link just names the conversation; access is
      // governed server-side by the conversation's share mode and grants.
      await navigator.clipboard.writeText(shareLinkForConversation(props.conversationId));
      notify(t('share.linkCopied'), "success");
    } catch (err) {
      notify(`${t('share.copyError')} ${(err as Error).message}`, "error");
    }
  };

  return (
    <>
      <ButtonGroup variant="outlined" size="small">
        <Button
          sx={{
            px: 1,
            py: 0,
            minHeight: 24,
            height: 24,
            fontSize: 11,
            "& .MuiSvgIcon-root": { fontSize: 15 },
          }}
          startIcon={<LockPersonIcon />}
          onClick={() => setDialogOpen(true)}
        >
          {t('share.button')}
        </Button>
        <S.ChevronButton
          aria-label={t('share.options')}
          onClick={(e) => setMenuAnchor(e.currentTarget)}
        >
          <ArrowDropDownIcon fontSize="small" />
        </S.ChevronButton>
      </ButtonGroup>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
      >
        <MenuItem onClick={copyLink}>
          <ListItemIcon>
            <LinkIcon fontSize="small" />
          </ListItemIcon>
          {t('share.copyLink')}
        </MenuItem>
      </Menu>

      <ShareConversationDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        conversationId={props.conversationId}
        conversationTitle={props.conversationTitle}
      />
    </>
  );
}
